import { CLASS_NAME } from 'constants/class-names'
import { copyValueToClipboard } from 'utils/system/clipboard'
import { EventType } from 'constants/enums'
import { Nullable } from 'constants/types'
import { ComponentBase } from 'utils/abstract-classes/component-base'

const { copyLink: className } = CLASS_NAME

export class CopyLinkComponent extends ComponentBase {
    /* eslint-disable-next-line no-magic-numbers */
    private readonly copyLinkTimeout = 5000
    private readonly copyLinkText = 'Copy Link'
    private readonly linkCopiedText = 'Link Copied'
    private readonly copyLinkTextEl: Nullable<HTMLElement>
    private readonly copyLinkURL: string

    /**
     * Initializes the copy link
     * @param {HTMLAnchorElement} copyLinkEl
     */
    public constructor(private copyLinkEl: HTMLAnchorElement) {
        super()

        this.copyLinkURL = copyLinkEl.href
        this.copyLinkTextEl = this.getElement(`.${className.text}`, copyLinkEl)

        // if nothing exists to copy don't attach events
        if (this.copyLinkURL) {
            // * attach events
            this.copyLinkEl.addEventListener(
                EventType.CLICK,
                (event: Event) => {
                    // Element copy link element is an anchor, prevent routing
                    event.preventDefault()
                    // run replacement behaviour (copy to clipboard and animate)
                    this.copyUrl()
                    // refocus keyboard from copy to the activating element
                    this.copyLinkEl.focus()
                }
            )
        }
    }

    /**
     * Copy URL to clipboard, update DOM for user feedback on action
     */
    public copyUrl(): void {
        // copy url to clip board
        copyValueToClipboard(this.copyLinkURL)

        // Add copied variant class
        // Change text
        this.copyLinkEl.classList.add(className.isCopied)

        if (this.copyLinkTextEl) {
            this.copyLinkTextEl.textContent = this.linkCopiedText
        }

        // Put it back after timeout
        setTimeout(() => {
            this.copyLinkEl.classList.remove(className.isCopied)

            if (this.copyLinkTextEl) {
                this.copyLinkTextEl.textContent = this.copyLinkText
            }
        }, this.copyLinkTimeout)
    }
}
